import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import * as actions from '../../../state';
import Header from '../header/Header';
import LeftSidebar from '../sidebars/LeftSidebar';
import RightSidebar from '../sidebars/RightSidebar';
import { selectLayout } from '../../../state';

function Wrapper({ content }) {
  const dispatch = useDispatch();
  const layout = useSelector(selectLayout);

  const toggleSidebar = (side, open) => {
    switch (side) {
      case 'left':
        dispatch(actions.showLeftSidebar(open));
        break;
      case 'right':
        dispatch(actions.showRightSidebar(open));
        dispatch(actions.editMode(false));
        break;
      default:
    }
  };

  return (
    <>
      <Header toggleSidebar={toggleSidebar} />
      { !layout.publicMode && <LeftSidebar toggleSidebar={toggleSidebar} /> }
      { !layout.publicMode && <RightSidebar toggleSidebar={toggleSidebar} /> }
      {content}
    </>
  );
}

export default Wrapper;
